const videoHelper = {
	el: {
		videoContainer: document.querySelector('.js-video'),
		btnPlayVideo: document.querySelector('.js-video-play'),
		btnPauseVideo: document.querySelector('.js-video-pause'),
		btnVideoSound: document.querySelector('.js-video-sound'),
		btnVideoFullscreen: document.querySelector('.js-video-fullscreen')
	},

	fxScrollToSection (videoPlayer) {
		const videoSrc = videoPlayer.src,
			url = new URL(videoSrc)
		
		const videoTarget = document.querySelector(`[data-src="${url.pathname}"]`)

		videoTarget.scrollIntoView({behavior: 'instant', block: 'center'})
	},
	
	fxFetchVideo (video) {
		fetch(video.querySelector('source').src)
			.then(response => {
				response.blob()
			})
			.then(blob => {
				video.srcObject = blob
				
				return video.play()
			})
			.catch(error => {
				console.log(error)
			})
	},

	fxTabSwitch(videoPlayer) {
		let inTab = true

		document.addEventListener('visibilitychange', () => {
			inTab = !inTab
			inTab && videoPlayer.parentElement.classList.contains('video-is-playing') ? videoPlayer.play() : videoPlayer.pause()
		})
	},

	fxToggleControls(videoPlayer) {
		let timer = 0
		const videoContainer = videoPlayer.parentElement,
			videoControls = videoContainer.querySelector('.video__controls'),
			warningMessage = videoContainer.querySelector('.video__progress-warning'),
			triggerElements = [videoPlayer, videoControls]
		
		for(const element of triggerElements) {
			element.addEventListener('mousemove', e => {
				if(timer) {
					clearTimeout(timer)
				}

				timer = setTimeout(() => {				
					videoContainer.classList.remove('controls--visible')
					warningMessage.classList.contains('show') && warningMessage.classList.remove('show')
				}, 2000)
				
				videoContainer.classList.contains('is-playing') && videoContainer.classList.add('controls--visible')
			})
		}
	},

	fxSetFullScreenVideo(btnFullscreen, videoPlayer) {
		if(!videoPlayer.requestFullscreen || !videoPlayer.webkitRequestFullscreen) 
			btnFullscreen.style.display = 'none'
			
		btnFullscreen.addEventListener('click', () => {
			videoPlayer.requestFullscreen && videoPlayer.requestFullscreen() || videoPlayer.webkitRequestFullscreen && videoPlayer.webkitRequestFullscreen()
		})
		videoPlayer.addEventListener('fullscreenchange', e => {
			e.currentTarget.parentElement.classList.toggle('video-is-fullscreen')
		})
	},

	fxUpdateTimeVideo (event) {
		const videoPlayer = event.target,
			videoContainer = videoPlayer.closest('.js-video')

		if(videoPlayer.readyState === 4 && videoContainer.classList.contains('is-playing')) {
			const percent = (videoPlayer.currentTime / videoPlayer.duration) * 100,
				percentRounded = Math.floor(percent),
				videoProgressBar = videoContainer.querySelector('.video__progress'),
				videoProgressDot = videoContainer.querySelector('.video__progress-dot')

			if(videoPlayer.currentTime || videoPlayer.duration) {
				videoProgressBar.value = percent
				videoProgressDot.style.left = `calc(-1rem + ${percent}%)`
			}
		}	
	},

	fxPlayVideo (videoPlayer, btnPlay) {
		const videoContainer = videoPlayer.parentElement

		if (videoPlayer.parentElement.classList.contains('video-is-fullscreen')) return
		
		if(videoPlayer.paused) {			
			videoPlayer.play()
				.catch(error => console.log('auto-play blocked:', error))
		}
	},

	fxToggleBtnPlayVideo(event) {
		const videoPlayer = event.target,
			videoContainer = videoPlayer.parentElement,
			btnVideoPlay = videoContainer.querySelector('.js-video-play')

		videoContainer.classList.toggle('is-playing')
		$(btnVideoPlay).fadeToggle(200)
	},

	fxPauseVideo (videoPlayer, btnPlay) {
		const videoContainer = videoPlayer.parentElement

		if (videoPlayer.parentElement.classList.contains('video-is-fullscreen')) return

		if(videoContainer.classList.contains('is-playing') && videoContainer.classList.contains('controls--visible') && !videoPlayer.paused) {
			videoPlayer.pause()
			videoContainer.classList.remove('controls--visible')
		}
	},

	fxToggleSound (videoPlayer) {
		const videoContainer = videoPlayer.parentElement

		videoContainer.classList.toggle('is-muted')
		videoPlayer.muted = !videoPlayer.muted
	},

	fxSetupVideoPlayer (element) {
		const videoPlayer = this.el.videoContainer.querySelector('video'),
			videoContainer = videoPlayer.parentElement,
			pathToAssets = window.location.pathname.includes('/campanhas/vale-consulta') ? '/campanhas/vale-consulta' : '',
			src = `${pathToAssets}${element.dataset.src}`,
			videoCurrentTime = element.dataset.videoProgress ? element.dataset.videoProgress : null

		// Reset player state
		Object.assign(videoPlayer, { src: '', preload: 'metadata'})
		//add data
		if(element.hasAttribute('data-video-progress')) {
			videoPlayer.dataset.videoProgress = videoCurrentTime
			videoPlayer.dataset.videoId = element.dataset.videoId
			videoPlayer.dataset.level = element.dataset.level
			videoPlayer.dataset.videoCompleted = element.dataset.videoCompleted
		}
		
		videoPlayer.load()

		//prevent video downlaod
		videoPlayer.setAttribute('oncontextmenu', 'return false')

		//event handlers - TODO
		const eventHandlers = {
			progress: this.fxHandleProgress,
			canplaythrough: this.fxEnableVideoControls,
			play: this.fxToggleBtnPlayVideo,
			volumechange: () => console.log('volume changed'),
			pause: this.fxToggleBtnPlayVideo,
			timeupdate: this.fxUpdateTimeVideo
		}

		Object.entries(eventHandlers).forEach(([event, handler]) => {
			videoPlayer.addEventListener(event, handler, { passive: true})
		})

		//set provisional progress
		if(videoPlayer.dataset.videoProgress > 0) {
			const videoProgress = videoContainer.querySelector('.video__progress')
			videoProgress.value = videoPlayer.dataset.videoProgress
		}

		//set video src
		videoPlayer.src = src
		videoPlayer.load()
	},

	fxHandleProgress() {
		const videoPlayer = this,
			{ buffered, duration } = videoPlayer,
			videoContainer = this.parentElement,
			loadingProgressBar = videoContainer.querySelector('.video__loading-progress')

		if (buffered.length === 0 || duration === 0) return

		const bufferedEnd = buffered.end(0),
			percent = (bufferedEnd / duration) * 100
		
		loadingProgressBar.value = percent
	},

	fxSetVideoCurrentTime(rangeSlider, videoPlayer) {
		rangeSlider.addEventListener('change', e => {
			videoPlayer.currentTime = e.currentTarget.value
		})
	},

	fxUpdateVideoCurrentTime (videoPlayer) {
		const videoContainer = videoPlayer.parentElement,
			videoProgressRange = videoContainer.querySelector('.video__progress-range'),
			videoProgress = videoContainer.querySelector('.video__progress')
		
		videoHelper.fxSetVideoCurrentTime(videoProgressRange, videoPlayer)
	},

	fxEnableVideoControls (event, isHtmlElement = false) {
		const videoPlayer = isHtmlElement ? event :event.target,
			videoContainer = videoPlayer.parentElement,
			readyState = videoPlayer.readyState,
			btnPlay = videoContainer.querySelector('.js-video-play'),
			btnPause = videoContainer.querySelector('.js-video-pause'),
			btnVideoSound = videoContainer.querySelector('.js-video-sound'),
			videoProgressRange = videoContainer.querySelector('.video__progress-range')

		//show/hide play btn
		if(readyState >= 4 && !videoContainer.classList.contains('is-playing')) {
			$(btnPlay).fadeIn(100)

			videoProgressRange.max = Math.floor(videoPlayer.duration)
			videoProgressRange.value = videoPlayer.currentTime

			videoHelper.fxUpdateVideoCurrentTime(videoPlayer)
		} else {
			$(btnPlay).fadeOut(100)
		}
	},

	fxUnloadVideo (videoPlayer) {
		const videoContainer = videoPlayer.parentElement,
			attributesToRemove =['preload', 'oncontextmenu'],
			videoProgress = videoContainer.querySelector('.video__progress'),
			videoProgressDot = videoContainer.querySelector('.video__progress-dot'),
			videoProgressRange = videoContainer.querySelector('.video__progress-range')

		videoContainer.classList.contains('is-playing') && videoContainer.classList.remove('is-playing')

		//restore sound if video muted
		if(videoPlayer.muted)
			videoPlayer.muted = false
		videoContainer.classList.contains('is-muted') && videoContainer.classList.remove('is-muted')

		videoProgress.value = ''
		videoProgressRange.removeAttribute('disabled')
		videoProgressRange.max = '100'
		videoProgressDot.style.left = '0px'
		videoPlayer.pause()
		videoPlayer.currentTime = 0
		//remove attributes
		for(const attribute of attributesToRemove) {
			videoPlayer.removeAttribute(attribute)
		}
		videoPlayer.src = ''
		videoPlayer.load()

		this.el.btnPlayVideo.style.display = 'none'
	},

	events () {
		const videoPlayer = this.el.videoContainer.querySelector('video')
		
		this.fxToggleControls(videoPlayer)

		this.el.btnVideoSound.addEventListener('click', () => {
			this.fxToggleSound(videoPlayer)
		})

		this.el.btnPlayVideo.addEventListener('click', e => {
			this.fxPlayVideo(videoPlayer, e.currentTarget)
		})

		this.el.btnPauseVideo.addEventListener('click', () => {
			this.fxPauseVideo(videoPlayer, this.el.btnPlayVideo)
		})

		this.fxSetFullScreenVideo(this.el.btnVideoFullscreen, videoPlayer)

		this.fxTabSwitch(videoPlayer)

		//scroll to section on exit fullscreen
		document.addEventListener('fullscreenchange', e => {
			!document.fullscreenElement && this.fxScrollToSection(e.target)
		})
	},

	init() {
		if(!this.el.videoContainer) return
		this.events()
	}
}

videoHelper.init()